import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    StyleSheet,
    Image,
    TouchableOpacity,
} from 'react-native';

import { pt, is_web } from '../../../common/utils';

const img = {
    home: require('../../../img/order_detail_index.png')
}

export default class ToIndex extends PureComponent {
    render() {
        return (
            <TouchableOpacity onPress={this.toindex} style={[st.container, is_web && {boxShadow: '0px 0px 8px -4px', zIndex: 1}]}>
                <Image style={st.homeIcon} source={img.home} />
            </TouchableOpacity>
        )
    }

    toindex = () => {
        this.context.router.toIndex();
    }

}

const st = StyleSheet.create({
    container: {
        position: 'fixed',
        right: pt(5),
        bottom: pt(100),
        width: pt(40),
        height: pt(40),
        backgroundColor: '#fff',
        borderRadius: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 3, height: 3 },
        // shadowRadius: 3,
        shadowOpacity: 0.8,
        elevation: 4
    },
    homeIcon: {
        width: pt(20)
    }
});

ToIndex.contextTypes = {
    router: PropTypes.object
};